import axios from "axios";
import Cookies from "js-cookie";

const mainBaseUrl = process.env.BACKEND_APIS_BASE_URL;
const apiBaseUrl = mainBaseUrl + "api/v1";

export const api = axios.create({
  baseURL: apiBaseUrl,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

